// const ErrorMsg = ({ msg }: { msg: string | undefined }) => {
const ErrorMsg = ({ msg }: { msg: any }) => {
	return <>{msg && <p style={{ color: '#c62828', fontSize: '16px', fontWeight: 400 }}> {msg} </p>}</>;
};

export default ErrorMsg;
